import ImageGallery from './ImageGallery.jsx';

export default ImageGallery;
